module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};



//////////////////
// WEBPACK FOOTER
// C:/Users/Administrator/Desktop/sailing-work/mapbox/mapboxProject/node_modules/_core-js@2.6.9@core-js/library/modules/_a-function.js
// module id = eu6x
// module chunks = 1